module.exports = __webpack_public_path__ + "img/icon04.aef831b1.png";